import { render, staticRenderFns } from "./ChecklistItem.vue?vue&type=template&id=3053dd9e&scoped=true"
import script from "./ChecklistItem.vue?vue&type=script&lang=js"
export * from "./ChecklistItem.vue?vue&type=script&lang=js"
import style0 from "./ChecklistItem.vue?vue&type=style&index=0&id=3053dd9e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3053dd9e",
  null
  
)

export default component.exports